module.exports = __webpack_public_path__ + "public/img/xcx.ed8a81a1.jpg";